/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRightLong,
  faArrowLeftLong,
} from '@fortawesome/free-solid-svg-icons';
import Proptypes from 'prop-types';
import parse from 'html-react-parser';
import LinkButton from '../../../components/Buttons/LinkButton';

function Lessons(props) {
  const {
    lessons,
    errorStatus,
    sucessStatus,
  } = props;
  const [lessonDisplaying, setLessonDisplaying] = React.useState(1);

  const handleNext = () => {
    if (lessonDisplaying < lessons.length) {
      setLessonDisplaying(lessonDisplaying + 1);
    }
  };

  const handlePrevious = () => {
    if (lessonDisplaying > 1) {
      setLessonDisplaying(lessonDisplaying - 1);
    }
  };

  let content;
  if (errorStatus) {
    content = <div className="text-red-500">An error occurred while fetching lessons</div>;
  } else if (sucessStatus) {
    content = (
      <div className="bg-sky-50 flex gap-2 xl:p-16 md:p-8 p-4 md:flex-nowrap flex-wrap">
        <div className="md:w-1/2 w-full xl:px-16 md:px-8 px-4 border-r border-gray-300 flex flex-col">
          <h1 className="font-semibold xl:text-3xl lg:text-xl text-md text-gray-600 md:my-4 my-2">
            LESSONS LEARNT
          </h1>
          <h2 className="font-bold md:text-lg text-sm text-gray-700 my-2">
            {parse(lessons[0].description)}
          </h2>
          <p className="md:text-md text-sm text-gray-700 my-1 md:mb-8 mb-2">
            <strong>Source: </strong>
            {lessons[0].source_detail}
          </p>
          <div className="flex items-center justify-self-end gap-4">
            <div>
              <p className="text-gray-600 text-xs">
                {new Date(lessons[0].date_reported).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 w-full md:px-16 px-4 flex flex-col">
          <h1 className="font-semibold xl:text-xl lg:text-lg text-md text-gray-600 md:my-4 my-2">
            MORE LESSONS
          </h1>
          <h2 className="font-bold md:text-lg text-sm text-gray-700 my-2">
            {parse(lessons[lessonDisplaying].description)}
          </h2>
          <p className="md:text-md text-sm text-gray-700 my-1 md:mb-8 mb-2">
            <strong>Source: </strong>
            {lessons[lessonDisplaying].source_detail}
          </p>
          <div>
            <div className="flex items-center justify-self-end justify-between w-full">
              <div className="mr-10">
                <p className="text-gray-600 text-sm">
                  {new Date(
                    lessons[lessonDisplaying].date_reported,
                  ).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </p>
              </div>
              <div className="flex gap-2 items-center">
                <p className="text-gray-600">{`Lesson ${lessonDisplaying + 1} of ${lessons.length}`}</p>
                {lessonDisplaying === 1 ? (
                  <FontAwesomeIcon
                    className="p-3 lg:text-2xl text-blue-500 text-lg bg-white rounded-full"
                    icon={faArrowLeftLong}
                    onClick={handlePrevious}
                  />
                ) : (
                  <FontAwesomeIcon
                    className="p-3 lg:text-5xl text-2xl bg-blue-500 text-white rounded-full cursor-pointer transition-transform hover:scale-110"
                    icon={faArrowLeftLong}
                    onClick={handlePrevious}
                  />
                )}
                {lessonDisplaying < lessons.length - 1 ? (
                  <FontAwesomeIcon
                    icon={faArrowRightLong}
                    className="p-3 lg:text-5xl text-2xl bg-blue-500 text-white rounded-full cursor-pointer transition-transform hover:scale-110"
                    onClick={handleNext}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faArrowRightLong}
                    className="p-3 lg:text-xl text-lg text-blue-500 bg-white rounded-full"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="lessons" className="xl:mx-24 lg:m-16 md:m-8 m-4">
      {content}

      <div className="flex flex-wrap p-4">
        <ul className="w-1/2 flex flex-col items-center md:p-8 p-4 gap-4 bg-white rounded-lg shadow-sm">
          <li>
            <h2 className="text-xl font-semibold text-center text-blue-800">VISION</h2>
            <p className="text-center text-gray-600">“The Safest, Most Efficient and Affordable Air Transport Service”</p>
          </li>
          <li>
            <h2 className="text-xl font-semibold text-center text-blue-800">MISSION</h2>
            <p className="text-center text-gray-600">
              “To Maintain the Highest Standards of Safety,
              Security and Service in Civil Aviation”
            </p>
          </li>
          <li>
            <h2 className="text-xl font-semibold text-center text-blue-800">OBJECTIVES</h2>
            <p className="text-center text-gray-600">
              “To promote the safe, secure, regular and efficient use
              and development of civil aviation inside and outside Uganda”
            </p>
          </li>
        </ul>
        <div className="flex flex-col items-center w-1/2 md:p-8 p-4 bg-white rounded-lg shadow-sm">
          <h2 className="md:text-3xl text-xl text-center font-bold my-3 w-1/2 text-blue-800">
            Safety is every persons responsibility
          </h2>
          <p className="text-gray-600">Safety begins with you</p>
          <LinkButton path="/public/report" linktext="Report Now" />
        </div>
      </div>

    </div>
  );
}

Lessons.propTypes = {
  lessons: Proptypes.arrayOf(Proptypes.shape({
    description: Proptypes.string.isRequired,
    source_detail: Proptypes.string.isRequired,
    date_reported: Proptypes.string.isRequired,
    source: Proptypes.string.isRequired,
  })).isRequired,
  errorStatus: Proptypes.bool.isRequired,
  sucessStatus: Proptypes.bool.isRequired,
};

export default Lessons;
